import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Phone, MessageCircle } from 'lucide-react';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_98529d53-1c35-46ad-aba2-5200ea95c0d0/artifacts/e42abu0c_WhatsApp%20Image%202026-02-04%20at%2021.41.32.jpeg"
          alt="ZOOM Academy Classroom"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 via-blue-800/90 to-blue-900/95"></div>
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE2YzAtNC40MTggMy41ODItOCA4LThzOCAzLjU4MiA4IDgtMy41ODIgOC04IDgtOC0zLjU4Mi04LTh6bS0yOCAwYzAtNC40MTggMy41ODItOCA4LThzOCAzLjU4MiA4IDgtMy41ODIgOC04IDgtOC0zLjU4Mi04LTh6bTE0IDE0YzAtNC40MTggMy41ODItOCA4LThzOCAzLjU4MiA4IDgtMy41ODIgOC04IDgtOC0zLjU4Mi04LTh6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 bg-yellow-400/90 text-gray-900 rounded-full font-semibold text-sm mb-6 shadow-lg animate-in fade-in slide-in-from-bottom-4 duration-700">
            <span className="relative flex h-2 w-2 mr-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gray-900 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-gray-900"></span>
            </span>
            Admissions Open for 2025-26
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight animate-in fade-in slide-in-from-bottom-6 duration-700 delay-100">
            Your Gateway to<br />
            <span className="text-yellow-400">HAU & Professional</span><br />
            <span className="text-yellow-400">Careers</span>
          </h1>

          {/* HAU Logo */}
          <div className="flex items-center space-x-4 mb-6 animate-in fade-in slide-in-from-bottom-8 duration-700 delay-150">
            <img 
              src="https://customer-assets.emergentagent.com/job_98529d53-1c35-46ad-aba2-5200ea95c0d0/artifacts/kvq01dpc_download.jpeg"
              alt="CCS HAU Logo"
              className="h-20 w-20 object-contain bg-white rounded-full p-2"
            />
            <div>
              <p className="text-xl font-bold text-yellow-400">CCS Haryana Agricultural University</p>
              <p className="text-blue-200">Official HAU Entrance Preparation Center</p>
            </div>
          </div>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-2xl animate-in fade-in slide-in-from-bottom-10 duration-700 delay-250">
            Expert Coaching for Agriculture, Fisheries, Nursing & Government Exams
          </p>

          {/* Features */}
          <div className="flex flex-wrap gap-4 mb-10 text-white animate-in fade-in slide-in-from-bottom-10 duration-700 delay-300">
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
              <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
              <span className="text-sm font-medium">5000+ Students Enrolled</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
              <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
              <span className="text-sm font-medium">1500+ Selections</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
              <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
              <span className="text-sm font-medium">Expert Faculty</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-in fade-in slide-in-from-bottom-12 duration-700 delay-400">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold text-lg px-8 py-6 shadow-2xl hover:shadow-yellow-400/50 transition-all duration-300 hover:scale-105"
            >
              Enroll Now
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <a href="tel:9991129789">
              <Button
                size="lg"
                variant="outline"
                className="w-full sm:w-auto bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-blue-900 font-bold text-lg px-8 py-6 shadow-xl transition-all duration-300 hover:scale-105"
              >
                <Phone className="mr-2 w-5 h-5" />
                Free Counseling
              </Button>
            </a>
            <a href="https://wa.me/919991129789" target="_blank" rel="noopener noreferrer">
              <Button
                size="lg"
                variant="outline"
                className="w-full sm:w-auto bg-green-500/20 backdrop-blur-sm border-2 border-green-400 text-white hover:bg-green-500 hover:text-white font-bold text-lg px-8 py-6 shadow-xl transition-all duration-300 hover:scale-105"
              >
                <MessageCircle className="mr-2 w-5 h-5" />
                WhatsApp Us
              </Button>
            </a>
          </div>

          {/* Contact Info */}
          <div className="mt-12 flex flex-col sm:flex-row gap-6 text-white animate-in fade-in duration-700 delay-500">
            <div className="flex items-center space-x-3">
              <Phone className="w-5 h-5 text-yellow-400" />
              <div>
                <p className="text-sm text-blue-200">Call us now</p>
                <a href="tel:9991129789" className="font-semibold hover:text-yellow-400 transition-colors">
                  99911-29789
                </a>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <Phone className="w-5 h-5 text-yellow-400" />
              <div>
                <p className="text-sm text-blue-200">Alternate</p>
                <a href="tel:8607029789" className="font-semibold hover:text-yellow-400 transition-colors">
                  86070-29789
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};

export default HeroSection;
